import { Controller } from 'stimulus'
import createChannel from '../channels/create_channel'
import CableReady from 'cable_ready'

export default class extends Controller {
  static values = {
    channel: String,
    params: Object,
    skipSubscription: Boolean
  }

  connect() {
    this.skipSubscriptionValue || this.connectToChannel()
  }

  disconnect() {
    this.skipSubscriptionValue || this.subscription.unsubscribe()
  }

  connectToChannel() {
    this.subscription = createChannel(
      {
        channel: this.channelValue,
        ...(this.hasParamsValue ? this.paramsValue : {})
      },
      {
        received(data) {
          if (data.cableReady) {
            CableReady.perform(data.operations)
          }
        }
      }
    )
  }
}
